export enum NotificationType {
  ExpireQuote = "QUOTE_EXPIRE",
  StatusChangeQuote = "QUOTE_STATUS_CHANGE",
  GeneralNotification = "GENERAL_INFORMATION",
  ReleaseNotes = "RELEASE_NOTES",
}
